var React = require("react");
const createReactClass = require("create-react-class");

var form = require("../../deploynaut/js/Form.jsx");

var MyComponent = createReactClass({

	getInitialState: function() {
		return {
			securityID: this.props.model.InitialSecurityID
		};
	},

	render: function() {
		if (this.props.model.Errors.length>0) {
			return (
				<div className="row">
					<div className="col-md-8">
						<div className="alert alert-danger" dangerouslySetInnerHTML={{__html:this.props.model.Errors.join('<br/>')}}/>
					</div>
				</div>
			);
		}

		return (
			<div className="row">
				<div className="col-md-8">
					<form.Form
						ref="myform"
						url={this.props.model.FormActionURL}
						securityID={this.state.securityID}
						buttonTitle="Add stack"
						buttonSubmittingTitle="Adding stack"
					>
						<div className="form-group">
							<label htmlFor="Name">Stack name</label>
							<form.Input name="Name" required validationError="Please enter a stack name" />
							<div className="help-text">Limited to alphanumeric characters, underscores and hyphens.</div>
						</div>
						<div className="form-group">
							<label>Git repository URL</label>
							<div className="help-text">Please contact our support team to add the Git URL.</div>
						</div>
					</form.Form>
				</div>
			</div>
		);
	}
});

module.exports = MyComponent;
